module.exports = __webpack_public_path__ + "static/media/hi.e676fecf.ogg";